import script from "./MazdaReplacePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaReplacePanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaReplacePanel.vue?vue&type=style&index=0&id=5cbf4f01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbf4f01"]])

export default __exports__